import { axiosInstanceGeneralConfig, axiosInstanceProducts } from "./instance";

export const getCompany = () => {
    return axiosInstanceGeneralConfig.get(`/company/headers`);
};

export const getBrands = (idBrand) => {
    return axiosInstanceGeneralConfig.get(`/brand/companies?companies=[${idBrand}]`);
};

export const getHeadquarters = () => {
    return axiosInstanceGeneralConfig.get(`/venue/all`);
};

export const getVenueByCity = (id) => {
    return axiosInstanceProducts.get(`/venues/getall?city=${id}`);
}